(() => {
  const pad = (value) => String(value).padStart(2, '0');

  const startTimer = (timer) => {
    if (timer.dataset.timerReady === 'true') return;
    timer.dataset.timerReady = 'true';

    const endTime = Date.parse(timer.dataset.endDate || '');
    const heading = timer.querySelector('.chtoys-product-timer__heading');
    if (Number.isNaN(endTime)) {
      timer.hidden = true;
      return;
    }

    let interval;
    const update = () => {
      const remaining = endTime - Date.now();
      if (remaining <= 0) {
        timer.classList.add('is-expired');
        if (heading) heading.textContent = timer.dataset.expiredText || 'This offer has ended.';
        if (interval) clearInterval(interval);
        return;
      }

      const totalSeconds = Math.floor(remaining / 1000);
      timer.querySelector('[data-days]').textContent = pad(Math.floor(totalSeconds / 86400));
      timer.querySelector('[data-hours]').textContent = pad(Math.floor((totalSeconds % 86400) / 3600));
      timer.querySelector('[data-minutes]').textContent = pad(Math.floor((totalSeconds % 3600) / 60));
      timer.querySelector('[data-seconds]').textContent = pad(totalSeconds % 60);
    };

    update();
    interval = setInterval(update, 1000);
  };

  const init = (root = document) => root.querySelectorAll('[data-chtoys-countdown]').forEach(startTimer);
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
